import useTranslation from 'next-translate/useTranslation';
import { usePersistedCountryDetails } from '../../../common/hooks';
import { localizeCurrency } from '../../../common/utils';
import { useUserInfo } from '../../../service/hooks';

const useWalletBalanceWithCurrency = () => {
  const { data: userInfo } = useUserInfo();
  const { lang } = useTranslation();
  const walletBalance = userInfo?.walletBalance;

  const [persistedCountryDetails] = usePersistedCountryDetails();
  const { title_en: currencyTitle } = persistedCountryDetails?.currency || {};
  const walletBalanceWithCurrency = currencyTitle && localizeCurrency(lang, { amount: walletBalance, currency: currencyTitle });
  return walletBalanceWithCurrency;
};

export default useWalletBalanceWithCurrency;
